import React, { Component } from 'react'


export default class Standing extends Component {
  render() {
      const {onClick} = this.props;
    return (
        <div className="text-center mt-5">
           
          <h2>Sitting or Standing</h2>
         
         
          <div className="mt-3">
              
              <p>Is the dizziness more of a lightheaded feeling that only occurs when standing up after sitting or laying in a resting position for a period of time? </p>
              <p>If rolling over in bed or reclining in a chair also triggers your dizziness, select “no”</p>
              
              <div className="mt-5 text-center">
                
                  <button className="btn btn-danger m-2  w-20"  onClick={onClick.bind(this,23,true)}>Yes</button>
                  <button className="btn btn-danger m-2  w-20"  onClick={onClick.bind(this,10,false)}>No</button>
                

              </div>
            </div>
         
        </div>

    )
  }
}
